window.Freebet = (function () {

    var _avaliableCount = 0;
    var _number = 0;
    var _title;
    var _isActive = false;
    var _isSelected = false;
    var _sum = 0;
    var _dom = {};

    var init = function () {
        _dom = {
            container: $('[js-node="coupon__item__selected--wrapper"]'),
            title: $('[js-node="coupon__item-body-title"]'),
            clearBtn: $('[js-node="coupon__item__button--clear"]'),
            activeSwitcherInput: $('[js-node="coupon__item-switcher"]'),
            constraintsContainer: $('[js-node="coupon__constraints-wrapper"]'),
            constraintsListContainer: $('[js-node="coupon__constraints-list"]')
        };

        readAvaliableCount();
        bindUI();
    };

    var readAvaliableCount = function () {
        _avaliableCount = 0;
        var infoContainer = $('#cart-freebet-info');
        if (infoContainer.length) {
            var parsedAvaliableCount = parseInt(infoContainer.attr('data-freebet-count'));
            if (!isNaN(parsedAvaliableCount))
                _avaliableCount = parsedAvaliableCount;
        }
    }

    var bindUI = function () {
        $(document).off('click', '#activationCouponBtn');
        $(document).on('click', '#activationCouponBtn', function (e) {
            var checkedId = $('input[name="Id"]:checked')[0].value;
            var container = $('.j-freebet-item[data-id="' + checkedId + '"]').first();
            var title = container.find('.j-freebet-item-event-name').text();
            var sum = container.find('[data-freebet-sum]').attr('data-freebet-sum');

            $(document).trigger('notification_SetFreebet', {
                number: checkedId,
                title: title,
                sum: sum
            });

            Popup.Close(this);
        });

        $(document).off('click', '#useCouponBtn');
        $(document).on('click', '#useCouponBtn', function (e) {
            var checkedId = $('input[name="Id"]:checked')[0].value;
            var container = $('.j-freebet-item[data-id="' + checkedId + '"]').first();
            var title = container.find('.j-freebet-item-event-name').text();
            var sum = container.find('[data-freebet-sum]').attr('data-freebet-sum');

            $(document).trigger('notification_UseCouponBeforeBet', {
                number: checkedId,
                title: title,
                sum: sum
            });

            Popup.Close(this);
        });

        $(document).off('click', '#useCurrencyBtn');
        $(document).on('click', '#useCurrencyBtn', function (e) {
            $(document).trigger('notification_SendBettingCart');

            Popup.Close(this);
        });

        $(document).off('notification_UseCouponBeforeBet');
        $(document).on('notification_UseCouponBeforeBet', function (e, data) {
            setFreebet(data);
            validate();
            BettingCart.send();
        });

        $(document).off('notification_SendBettingCart');
        $(document).on('notification_SendBettingCart', function (e) {
            BettingCart.send();
        });

        $(document).off('notification_SetFreebet');
        $(document).on('notification_SetFreebet', function (e, data) {
            setFreebet(data);
            validate();
        });

        $(document).off('notificationCoefInCartUpdate notificationCoefIsAddedToCart notificationCoefIsRemovedFromCart notificationCartTypeIsChanged notificationCoefIsSelectedChanged notification_notWinEventCountChanged');
        $(document).on('notificationCoefInCartUpdate notificationCoefIsAddedToCart notificationCoefIsRemovedFromCart notificationCartTypeIsChanged notificationCoefIsSelectedChanged notification_notWinEventCountChanged', function (e, data) {
            if (_isSelected) {
                validate();                
            }

            e.stopImmediatePropagation();
            return false;
        });

        _dom.clearBtn.off('click');
        _dom.clearBtn.on('click', function () {
            clear();
        });

        _dom.activeSwitcherInput.off('change');
        _dom.activeSwitcherInput.on('change', function () {
            setIsSelected($(this).is(':checked'));
        });
    };

    var setIsSelected = function (isSelected) {        
        if (isSelected) {
            _isSelected = true;
            _dom.activeSwitcherInput.prop('checked', true);
            $('#classic-betting-cart').addClass('m-freebet-is-active');
            _dom.constraintsContainer.show();
        } else {
            _isSelected = false;
            _dom.activeSwitcherInput.prop('checked', false);
            $('#classic-betting-cart').removeClass('m-freebet-is-active');
            _dom.constraintsContainer.hide();
        }

        BettingCart.calc();
        BettingCart.validate();
    }

    var setFreebet = function (data) {
        if (_avaliableCount === 0) {
            clear();
            return;
        }

        _number = data.number / 1;
        _title = data.title;
        _isActive = true;
        _isSelected = data.hasOwnProperty('isSelected') ? data.isSelected : true;
        _sum = parseInt(data.sum);        
        _dom.title.text(_title);

        $('#cart__freebet-sum-value').html(_sum);
        $('#classic-betting-cart').addClass('m-freebet');

        setSingleItemAfterFreebetProposalSelect();
        setIsSelected(_isSelected);
    };

    var isActive = function () {
        return _isActive;
    };

    var isSelected = function () {
        return _isSelected;
    };

    var getTitle = function () {
        return _title;
    };

    var getSum = function () {
        return _sum;
    };

    var getAvaliableCount = function () {
        return _avaliableCount;
    };

    var clear = function () {
        _title = "";
        _number = 0;
        _isActive = false;
        _isSelected = false;

        $('#classic-betting-cart').removeClass('m-freebet');
        setIsSelected(false);

        _dom.constraintsListContainer.empty();
    };

    var convertCartTypeToInt = function (typeName) {
        //Single || Express || System

        switch (typeName) {
            case 'Single':
                return 4;
            case 'Express':
                return 1;
            case 'System':
                return 2;
            default:
                return 0;
        }
    };

    var humanizeCouponResult = function (code) {
        switch (code) {
            case 1: return window.Localization.getString('Scripts_Shared_Modules.Freebet_36', 'Успешно');
            case 2: return window.Localization.getString('Scripts_Shared_Modules.Freebet_37', 'Ставка не соотвествует купону');
            case 3: return window.Localization.getString('Scripts_Shared_Modules.Freebet_38', 'Срок действия купона истек');
            case 4: return window.Localization.getString('Scripts_Shared_Modules.Freebet_39', 'Не все условия выполнены');
            case 5: return window.Localization.getString('Scripts_Shared_Modules.Freebet_40', 'Корзина пуста');
            case 6: return window.Localization.getString('Scripts_Shared_Modules.Freebet_41', 'Некорректная область использования');
            default: return "";
        }
    }

    var renderConstraints = function (data) {
        let html = '';

        let hasRequirement = typeof (data.Requirement) !== "undefined" && data.Requirement !== null && data.Requirement.length > 0;
        let hasErrorMessage = typeof (data.ErrorMessage) !== "undefined" && data.ErrorMessage !== null && data.ErrorMessage.length > 0;

        if ((!hasRequirement && !hasErrorMessage) || !_isSelected) {
            _dom.constraintsContainer.hide();
        }
        else {
            _dom.constraintsContainer.show();
        }

        if (hasRequirement) {
            data.Requirement.forEach(r => {
                html += '<div class="freebet-constrains-item">';
                html += r.IsValid ? app.htmlSvgIcon('ok', 'freebet-constrains-item__icon m-success') : app.htmlSvgIcon('error', 'freebet-constrains-item__icon m-fail');
                html += r.Description;
                html += '</div>';
            });
        }

        if (hasErrorMessage) {
            html += '<div class="freebet-constrains-item">';
            html += app.htmlSvgIcon('error', 'freebet-constrains-item__icon m-fail');
            html += data.ErrorMessage;
            //html += humanizeCouponResult(data.Result);
            html += '</div>';
        }

        _dom.constraintsListContainer.html(html);
    };

    var setSingleItemAfterFreebetProposalSelect = function () {
        if (StandardCart.isTypeSingle()) {
            var selectedItemForFreebet = StandardCart.getSingleSelectedItemForFreebetProposal();
            if (selectedItemForFreebet) {
                setSelectetItem(selectedItemForFreebet.originalId);
            }
        }
    };

    var addPosition = function(items, item) {
        items.push({ CoefId: item.actualId, Value: item.originalCoefValue, EventId: item.eventId });
        return items;
    }

    var getPositionsForProposal = function () {
        var items = BettingCart.getItems();
        var positions = [];

        if (StandardCart.isTypeSingle()) {
            var selectedItemForFreebet = StandardCart.getSingleSelectedItemForFreebetProposal();
            if (selectedItemForFreebet) {
                addPosition(positions, selectedItemForFreebet);
            }
        } else {
            for (var key in items) {
                if (items[key].isSelected) {
                    addPosition(positions, items[key]);
                }
            }
        }

        return positions;
    };

    var getPositions = function () {
        var items = BettingCart.getItems();
        var positions = [];

        if (StandardCart.isTypeSingle()) {
            var selectedItemForFreebet = StandardCart.getSelectedItemForFreebet();

            if (selectedItemForFreebet) {
                addPosition(positions, selectedItemForFreebet);
            }
        } else {
            for (var key in items) {
                if (items[key].isSelected) {
                    addPosition(positions, items[key]);
                }
            }
        }

        return positions;
    };

    var getSelectedItemId = function () {
        return parseInt($('[name="cart-item-freebet-radio"]:checked').val()) || null;
    };

    var setSelectetItem = function (originalId) {
        $('[name="cart-item-freebet-radio"][value=' + originalId + ']').attr('checked', true);
    }

    var validate = function () {
        Ajax.postJson("/bettingcart/checkcoupon", {
            data: {
                cartModel: {
                    CartType: convertCartTypeToInt(StandardCart.getType()),
                    NotWinEventCount: StandardCart.getNotWinEventsCount(),
                    TotalConstantsCount: 0,
                    Positions: getPositions()
                },
                couponId: _number
            },
            success: function (data) {
                if (StandardCart.isTypeSingle() && StandardCart.quantity() > 0 && !getSelectedItemId()) {
                    data.ErrorMessage = window.Localization.getString('Scripts_Shared_Modules.Freebet_42', 'Выберите один из исходов в корзине');
                }                

                renderConstraints(data);
            },
            error: function () {                
                console.log('error checkCoupon');
            }
        });
    };

    var proposeCouponList = function () {
        Ajax.postJson("/bettingcart/proposesuitablecouponList", {
            data: {
                cartModel: {
                    CartType: convertCartTypeToInt(StandardCart.getType()),
                    NotWinEventCount: StandardCart.getNotWinEventsCount(),
                    TotalConstantsCount: 0,
                    Positions: getPositionsForProposal()
                }
            },
            success: function (resp) {
                if (!resp.hasCoupons) {
                    BettingCart.send();
                }
                else {
                    new AwesomeScrollbar('#freebet-popup-list', 'freebet-popup__scrollarea');
                }
            }
        });
    };

    var getFreebetId = function () {
        return _number;
    };

    var updateFullCartBlock = function () {
        Ajax.postJson("/bettingcart/updatefreebet", {
            success: function () {
                init();
            }
        });
    };

    var updateInfoRow = function () {
        Ajax.postJson("/bettingcart/updatefreebetinfo", {
            success: function () {
                readAvaliableCount();
            }
        });
    };

    var updateAfterSuccessSend = function () {
        clear();
        updateInfoRow();
    };

    var updateAfterFailedSend = function () {
        updateInfoRow();
    };


    return {
        init: init,
        clear: clear,
        getSelectedItemId: getSelectedItemId,
        getFreebetId: getFreebetId,
        isActive: isActive,
        isSelected: isSelected,
        getSum: getSum,
        getTitle: getTitle,
        validate: validate,
        getAvaliableCount: getAvaliableCount,
        proposeCouponList: proposeCouponList,
        updateAfterSuccessSend: updateAfterSuccessSend,
        updateAfterFailedSend: updateAfterFailedSend
    };
}());